// generated
export const GATEWAY_VERSION = "0.23.0";
